export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-lastfm-b8601dfb140519e6e795cd7bd791fe0c.svg";